<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
  <div fxFlex>Edit Selected Contacts</div>
  <button mat-icon-button [mat-dialog-close]="false" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="form" novalidate>
    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
      Error occurred
    </div>

    <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="canEditTags" class="section-holder">
      <app-mat-checkbox-input fxFlex [formControl]="tagsEnableControl" (ngModelChange)="onOtherEnableChange($event)"
                              label="Edit Tags for Selected Contacts"
                              name="tagsEnable"></app-mat-checkbox-input>

      <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="tagsEnableControl.getRawValue()" fxLayoutGap="10px">
        <app-mat-tags-multiselect fxFlex [formControl]="tagsControl" label="Tags" name="tags"
                                  placeholder="Type here to start search tags"
                                  [autoCompleteValues]="contactService.allTags"
                                  [suffixIcon]="canEditTags ? 'edit' : undefined"
                                  suffixTooltip="Manage Tags"
                                  (onSuffixClicked)="onManageTagsClick($event)"
                                  [submitted]="submitted">
        </app-mat-tags-multiselect>
        <div style="margin-bottom: 20px">
          <mat-radio-group [formControl]="tagsMergeTypeControl" class="radio-group" fxLayout="column" fxLayoutGap="10px">
            <mat-radio-button value="append">Keep all current tags</mat-radio-button>
            <mat-radio-button value="replace">Replace all current tags</mat-radio-button>
            <!--<mat-radio-button *ngIf="canDeleteCompanyContacts || canDeletePrivateContacts" value="delete" color="warn">
              <span class="p-error">Delete selected contacts</span></mat-radio-button>-->
          </mat-radio-group>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="canEdit" class="section-holder" fxLayoutGap="10px">
      <app-mat-checkbox-input fxFlex [formControl]="syncWithPbxEnableControl" (ngModelChange)="onOtherEnableChange($event)"
                              label="Sync Selected Contacts with Phone System"
                              name="syncWithPbxEnable"></app-mat-checkbox-input>

      <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="syncWithPbxEnableControl.getRawValue()" fxLayoutGap="10px">
        <app-mat-slide-toggle-input [formControl]="syncWithPbxControl"
                                    name="syncPbx" color="primary" label="Sync with Phone System">
        </app-mat-slide-toggle-input>

        <div class="alert alert-info" role="alert">
          Only Company wide contacts can be synchronized with Phone System.
        </div>
      </div>
    </div>


    <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="canDeleteCompanyContacts || canDeletePrivateContacts" class="section-holder" fxLayoutGap="10px">
      <app-mat-checkbox-input fxFlex [formControl]="deleteEnableControl" (ngModelChange)="onDeleteEnableChange($event)"
                              label="Delete Selected Contacts" name="deleteEnabled"></app-mat-checkbox-input>

      <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="deleteEnableControl.getRawValue()" fxLayoutGap="10px">
        <div class="alert alert-danger" role="alert" *ngIf="totalSelected !== totalFiltered">
          You selected {{ totalSelected }} contacts of {{ totalFiltered }} to DELETE. Once deleted, it cannot be restored.
          <br>
          Click <a [routerLink]="null" style="cursor: pointer; color: initial;" (click)="selectAllContacts()">here</a> to
          select all contacts
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="totalSelected === totalFiltered">
          You selected {{ totalSelected }} to DELETE. Once deleted, it cannot be restored.
        </div>

        <div class="alert alert-warning" role="alert" *ngIf="limitedDeleteAccess">
          Please be aware that with your current permissions, you are only authorized to delete certain contacts. Thus, not
          all selected contacts may be successfully deleted during this process.
        </div>
      </div>
    </div>

    <div class="alert alert-warning" role="alert" *ngIf="tagsEnableControl.getRawValue() || syncWithPbxEnableControl.getRawValue()">
      You selected {{ totalSelected }} contacts of {{ totalFiltered }} to edit. <br>
      Click <a [routerLink]="null" style="cursor: pointer; color: initial;" (click)="selectAllContacts()">here</a>
      to select all contacts
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <app-long-task-button
    [clickFunction]="onSubmit.bind(this)"
    loadingColor="warn"
    tooltip="Sync Contacts Manually"
    buttonTitle="Submit"
    [hideIcon]="true"
    [taskKey]="getTaskKey()"
  ></app-long-task-button>
  <!--<button mat-button color="primary" cdkFocusInitial (click)="onSubmit()" [promiseBtn]="buttonSubmitPromise">Submit
  </button>-->
</mat-dialog-actions>
